module.exports = __webpack_public_path__ + "img/selected-tile-icon.02a00218.svg";